export class SurveyAnswer {
 }
